import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";

import { useShiftDiscoveryUserFiltersContext } from "../../ShiftDiscovery/Filters/useUserFiltersContext";

interface CalendarFilters {
  getOpenShiftsFilter: () => {
    timezone: string;
    area: {
      latitude: number;
      longitude: number;
      radiusInMiles: number;
    };
    qualifications: string[];
    includeWindowedOutShifts: boolean;
  };
  getUrgentShiftsFilter: () => {
    isUrgent: boolean;
    area: {
      latitude: number;
      longitude: number;
      radiusInMiles: number;
    };
  };
}

export function useCalendarFilters(timezone: string): CalendarFilters {
  const workerGeoLocation = useWorkerGeoLocation();
  const { distance, licenses, includeWindowedOutShifts } = useShiftDiscoveryUserFiltersContext();

  const windowedOutShiftsEnabled = useCbhFlag(CbhFeatureFlag.INCLUDE_WINDOWED_OUT_SHIFTS, {
    defaultValue: false,
  });

  const getOpenShiftsFilter = () => {
    const includeWindowedOutShiftsFilter = windowedOutShiftsEnabled
      ? includeWindowedOutShifts ?? true
      : false;

    return {
      timezone,
      area: {
        latitude: workerGeoLocation?.latitude ?? 0,
        longitude: workerGeoLocation?.longitude ?? 0,
        radiusInMiles: distance,
      },
      qualifications: licenses ?? [],
      includeWindowedOutShifts: includeWindowedOutShiftsFilter,
    };
  };

  const getUrgentShiftsFilter = () => ({
    isUrgent: true,
    area: {
      latitude: workerGeoLocation?.latitude ?? 0,
      longitude: workerGeoLocation?.longitude ?? 0,
      radiusInMiles: distance,
    },
  });

  return {
    getOpenShiftsFilter,
    getUrgentShiftsFilter,
  };
}
